import { render, staticRenderFns } from "./DepositOption.vue?vue&type=template&id=6a62a88e&scoped=true&"
import script from "./DepositOption.vue?vue&type=script&lang=ts&"
export * from "./DepositOption.vue?vue&type=script&lang=ts&"
import style0 from "./DepositOption.vue?vue&type=style&index=0&id=6a62a88e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a62a88e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
